import React, { useEffect,  useRef, useState } from "react";

import Cookies from "js-cookie";
import { useDispatch, useSelector } from "react-redux";
import { Col, Row, Offcanvas, Button } from "react-bootstrap";
import { FiMenu } from "react-icons/fi";
import FASDroupdownFilterBox from "../../../../../components/FilterBox/FASFilter/FASDropDownFilter";
import { format } from "date-fns";
import FASTable from "../../../../../components/Tables/FASTable";
import { FilterMain } from "../../../../../Redux/Slice/login/loginSlice";
import {
  SaleBook,
  SaleParty,
  SalesDashboard,
  SalesItemMonth,
} from "../../../../../Redux/Slice/Fas/DayBook Analysis/Sale/SaleSlice";
import { Loader } from "../../../../../components/Loader/Loader";
import FASFilter from "../../../../../components/FilterBox/FASFilter/FASFilter";
import { useTheme } from "../../../../../Themecontext/Themecontext";

export const ItemWiseMonthWise = () => {
  const dispatch = useDispatch();
  const { Colourdata, mainFilterData, DataMain } = useSelector(
    (state) => state.ClientLogin,
  );
  const {
    SaleBookdata,
    SalePartydata,
    SalesItemMonthdata,
    SalesDashboarddata,
  } = useSelector((state) => state.SaleSlice);

  const iscolour = Colourdata?.data?.find((el) => el.ExeName === "NEWFAS");
  const iscolourDark = Colourdata?.data?.find(
    (el) => el.ExeName === "NEWFASDARK",
  );

  const { theme } = useTheme();
  const isdark = theme;
  const Firm = Cookies.get("Firm");
  const YearId = Cookies.get("FinancialYear");

  const FinancialYear = Cookies.get("FinancialYear");

  const [dateRange, setDateRange] = useState([
    {
      startDate: null,
      endDate: null,
      key: "selection",
    },
  ]);

  function parseRangeToDates(rangeString) {
    if (!rangeString) return { startDate: null, endDate: null };

    const [startStr, endStr] = rangeString.split(" - ");

    const parseDDMMYYYY = (s) => {
      const [day, month, year] = s.split("/").map(Number);
      return new Date(year, month - 1, day);
    };

    return {
      startDate: parseDDMMYYYY(startStr),
      endDate: parseDDMMYYYY(endStr),
    };
  }

  const isFYDateSet = useRef(false);

  useEffect(() => {
    if (!DataMain || !FinancialYear) return;
    if (isFYDateSet.current) return;

    let matchedYear = null;

    DataMain?.AC_Year_List?.forEach((el) => {
      if (el.AcYearID === Number(FinancialYear)) {
        matchedYear = el.AcYear;
      }
    });

    if (matchedYear) {
      const { startDate, endDate } = parseRangeToDates(matchedYear);

      setDateRange([
        {
          startDate,
          endDate,
          key: "selection",
        },
      ]);

      isFYDateSet.current = true;
    }
  }, [DataMain, FinancialYear]);

  const startDate = dateRange?.[0]?.startDate;
  const endDate = dateRange?.[0]?.endDate;

  const safeFormat = (date) => {
    if (!date || isNaN(new Date(date))) return null;
    return format(new Date(date), "yyyy-MM-dd");
  };
  useEffect(() => {
    dispatch(SaleBook({ Firm, Year: YearId }));
    dispatch(SaleParty({ Firm, Year: YearId }));
    dispatch(FilterMain({ Firm, Year: YearId }));
  }, [dispatch, Firm, YearId]);

  useEffect(() => {
    if (!startDate || !endDate) return;

    const payload = {
      Firm,
      Year: YearId,
      selectestartdate: safeFormat(startDate),
      selectenddate: safeFormat(endDate),
    };

    dispatch(SalesDashboard(payload));
    dispatch(SalesItemMonth(payload));
  }, [startDate, endDate, Firm, YearId, dispatch]);

  const [filters, setFilters] = useState({
    month: [],
    saleBook: [],
    productionGroup: [],
    saleParty: [],
  });
  const [search, setSearch] = useState({
    month: "",
    saleBook: "",
    productionGroup: "",
    saleParty: "",
  });

  const [selectedMonth, setSelectedMonth] = useState("");
  const [selectedMonthId, setSelectedMonthId] = useState([]);

  const [selectedSaleBook, setSelectedSaleBook] = useState("");
  const [selectedSaleBookId, setSelectedSaleBookId] = useState([]);

  const [selectedProductionGroup, setSelectedProductionGroup] = useState("");
  const [selectedProductionGroupId, setSelectedProductionGroupId] = useState(
    [],
  );

  const [selectedSaleParty, setSelectedSaleParty] = useState("");
  const [selectedSalePartyId, setSelectedSalePartyId] = useState([]);
  const monthOptions = [
    { id: 4, month: "April" },
    { id: 5, month: "May" },
    { id: 6, month: "June" },
    { id: 7, month: "July" },
    { id: 8, month: "August" },
    { id: 9, month: "September" },
    { id: 10, month: "October" },
    { id: 11, month: "November" },
    { id: 12, month: "December" },
    { id: 1, month: "January" },
    { id: 2, month: "February" },
    { id: 3, month: "March" },
  ];
  const monthList =
    monthOptions?.map((item) => ({
      label: item?.month,
      value: item?.month,
    })) || [];
  const saleBookList =
    SaleBookdata?.BookName?.map((item) => ({
      label: item?.BookName,
      value: item?.BookId,
    })) || [];
  const salePartyList =
    SalePartydata?.BookName?.map((item) => ({
      label: item?.AcName,
      value: item?.AcID,
    })) || [];

  const productionList =
    mainFilterData?.production_Group_Master_List?.map((item) => ({
      label: item?.ProductionGroupMstName,
      value: item?.ProductionGroupMstID,
    })) || [];
  const [showFilter, setShowFilter] = useState(false);
  const handleClose = () => setShowFilter(false);
  const handleShow = () => setShowFilter(true);
  const [isFilterLoading, setIsFilterLoading] = useState(false);
  const getRowsdata = () => {
    return (
      SalesItemMonthdata?.Dtl?.map((item, index) => ({
        // srNumber: index + 1,
        ...item,
      })) || []
    );
  };
  const getColumns = [
    // { label: "Chart", key: "charts", align: "center" },
    { label: "Sr. No.", key: "srNumber", align: "center" },
    {
      label: "Item",
      key: "ItemName",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    { label: "Net Amount", key: "NetAmount", align: "right", format: "true" },
    { label: "April Amount", key: "AprAmt", align: "right", format: "true" },
    { label: "April Quantity", key: "AprQty", align: "right", format: "true" },
    { label: "April Price", key: "AprPrice", align: "right", format: "true" },
    { label: "May Amount", key: "MayAmt", align: "right", format: "true" },
    { label: "May Quantity", key: "MayQty", align: "right", format: "true" },
    { label: "May Price", key: "MayPrice", align: "right", format: "true" },
    { label: "June Amount", key: "JunAmt", align: "right", format: "true" },
    { label: "June Quantity", key: "JunQty", align: "right", format: "true" },
    { label: "June Price", key: "JunPrice", align: "right", format: "true" },
    { label: "July Amount", key: "JulAmt", align: "right", format: "true" },
    { label: "July Quantity", key: "JulQty", align: "right", format: "true" },
    { label: "July Price", key: "JulPrice", align: "right", format: "true" },
    { label: "August Amount", key: "AugAmt", align: "right", format: "true" },
    { label: "August Quantity", key: "AugQty", align: "right", format: "true" },
    { label: "August Price", key: "AugPrice", align: "right", format: "true" },
    {
      label: "September Amount",
      key: "SepAmt",
      align: "right",
      format: "true",
    },
    {
      label: "September Quantity",
      key: "SepQty",
      align: "right",
      format: "true",
    },
    {
      label: "September Price",
      key: "SepPrice",
      align: "right",
      format: "true",
    },
    { label: "Octomber Amount", key: "OctAmt", align: "right", format: "true" },
    {
      label: "Octomber Quantity",
      key: "OctQty",
      align: "right",
      format: "true",
    },
    {
      label: "Octomber Price",
      key: "OctPrice",
      align: "right",
      format: "true",
    },
    { label: "November Amount", key: "NovAmt", align: "right", format: "true" },
    {
      label: "November Quantity",
      key: "NovQty",
      align: "right",
      format: "true",
    },
    {
      label: "November Price",
      key: "NovPrice",
      align: "right",
      format: "true",
    },
    { label: "December Amount", key: "DecAmt", align: "right", format: "true" },
    {
      label: "December Quantity",
      key: "DecQty",
      align: "right",
      format: "true",
    },
    {
      label: "December Price",
      key: "Decprice",
      align: "right",
      format: "true",
    },
    { label: "January Amount", key: "JanAmt", align: "right", format: "true" },
    {
      label: "January Quantity",
      key: "JanQty",
      align: "right",
      format: "true",
    },
    { label: "January Price", key: "JanPrice", align: "right", format: "true" },
    { label: "February Amount", key: "FebAmt", align: "right", format: "true" },
    {
      label: "February Quantity",
      key: "FebQty",
      align: "right",
      format: "true",
    },
    {
      label: "February Price",
      key: "FebPrice",
      align: "right",
      format: "true",
    },
    { label: "March Amount", key: "MarAmt", align: "right", format: "true" },
    { label: "March Quantity", key: "MarQty", align: "right", format: "true" },
    { label: "March Price", key: "MarPrice", align: "right", format: "true" },
  ];
  const toggleItem = (type, item) => {
    setFilters((prev) => ({
      ...prev,
      [type]: prev[type].includes(item.value) ? [] : [item.value],
    }));
  };
  const selectAll = (type, items) => {
    const allIds = items.map((i) => i.value);

    setFilters((prev) => ({
      ...prev,
      [type]: prev[type].length === items.length ? [] : allIds,
    }));
  };
  const handleSearch = (type, value) => {
    setSearch((prev) => ({
      ...prev,
      [type]: value,
    }));
  };

  const applyFilter = async () => {
    setIsFilterLoading(true);

    try {
      const payload = {
        Firm,
        Year: YearId,
        selecteBookdIds: filters.saleBook.toString(),
        selectePdGroupdIds: filters.productionGroup.toString(),
        selectSalepartyIds: filters.saleParty.toString(),
        selectmonthname: filters.month.toString(),
        selectestartdate: safeFormat(startDate),
        selectenddate: safeFormat(endDate),
      };

      await dispatch(SalesItemMonth(payload));

      await dispatch(SalesDashboard(payload));
    } finally {
      setIsFilterLoading(false);
    }
  };
  const applyFilter1 = async () => {
    setIsFilterLoading(true);

    try {
      const payload = {
        Firm,
        Year: YearId,
        selecteBookdIds: selectedSaleBookId?.toString() || "",
        selectePdGroupdIds: selectedProductionGroupId?.toString() || "",
        selectSalepartyIds: selectedSalePartyId?.toString() || "",
        selectmonthname: selectedMonthId?.toString() || "",
        selectestartdate: safeFormat(startDate),
        selectenddate: safeFormat(endDate),
      };

      await dispatch(SalesItemMonth(payload));

      await dispatch(SalesDashboard(payload));
    } finally {
      setIsFilterLoading(false);
    }
  };

  const formatIndianRupee = (amount) =>
    new Intl.NumberFormat("en-IN", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(amount);

  const summaryData = {
    totalSaleAmount: formatIndianRupee(
      SalesDashboarddata?.MonthDtl?.[0]?.NetAmount || 0,
    ),
    totalQuantitySold: formatIndianRupee(
      SalesDashboarddata?.MonthDtl?.[0]?.Finishmeter || 0,
    ),
    averageSaleAmount: formatIndianRupee(
      SalesDashboarddata?.MonthDtl?.[0]?.AvgAmt || 0,
    ),
  };
  const cardStyle = {
    background: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour2,
    border: `1px solid ${
      isdark === "light" ? iscolour?.Colour3 : iscolourDark?.Colour10
    }`,
    borderLeft: `6px solid ${
      isdark === "light" ? iscolour?.Colour6 : iscolourDark?.Colour10
    }`,
    borderRadius: "12px",
    padding: "10px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    height: "100%",
  };

  const titleStyle = {
    color: isdark === "light" ? iscolour?.Colour12 : iscolourDark?.Colour12,
    fontWeight: "600",
  };

  const subtitleStyle = {
    marginTop: "10px",
    fontWeight: "500",
    color: isdark === "light" ? iscolour?.Colour6 : iscolourDark?.Colour10,
  };
  const isLoading =
    !SaleBookdata || !SalePartydata || !SalesItemMonthdata || !mainFilterData;

  if (isLoading || isFilterLoading) {
    return <Loader />;
  }
  return (
    <div
      style={{
        padding: "16px",
        background: isdark === "light" ? "#f7efdd " : iscolourDark?.Colour2,
        minHeight: "100vh",
      }}
    >
      {/* ✅ MOBILE BUTTON */}
      <div className="d-lg-none d-flex justify-content-end mb-3">
        <Button
          onClick={handleShow}
          style={{
            backgroundColor:
              isdark === "light" ? iscolour?.Colour6 : iscolourDark?.Colour8,
            color:
              isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour3,
            border: "none",
            borderRadius: "10px",
            padding: "8px 12px",
            boxShadow: "0 4px 10px rgba(0,0,0,0.18)",
          }}
        >
          <FiMenu size={22} />
        </Button>
      </div>

      {/* ✅ OFFCANVAS */}
      <Offcanvas
        show={showFilter}
        onHide={handleClose}
        placement="start"
        style={{
          background: isdark === "light" ? "#f7efdd " : iscolourDark?.Colour2,
        }}
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title
            style={{ color: isdark === "light" ? "#000" : "#fff" }}
          >
            Filters
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div
            style={{ display: "flex", flexDirection: "column", gap: "20px" }}
          >
            {/* Month */}
            <FASFilter
              title="Month"
              items={monthList}
              search={search.month}
              setSearch={(val) => handleSearch("month", val)}
              selectedItems={filters.month}
              toggleItem={(item) => toggleItem("month", item)}
              selectAll={() => selectAll("month", monthList)}
            />

            {/* Sale Books */}
            <FASFilter
              title="Sale Books"
              items={saleBookList}
              search={search.saleBook}
              setSearch={(val) => handleSearch("saleBook", val)}
              selectedItems={filters.saleBook}
              toggleItem={(item) => toggleItem("saleBook", item)}
              selectAll={() => selectAll("saleBook", saleBookList)}
            />

            {/* Production Groups */}
            <FASFilter
              title="Production Groups"
              items={productionList}
              search={search.productionGroup}
              setSearch={(val) => handleSearch("productionGroup", val)}
              selectedItems={filters.productionGroup}
              toggleItem={(item) => toggleItem("productionGroup", item)}
              selectAll={() => selectAll("productionGroup", productionList)}
            />

            {/* Sale Party */}
            <FASFilter
              title="Sale Party"
              items={salePartyList}
              search={search.saleParty}
              setSearch={(val) => handleSearch("saleParty", val)}
              selectedItems={filters.saleParty}
              toggleItem={(item) => toggleItem("saleParty", item)}
              selectAll={() => selectAll("saleParty", salePartyList)}
            />

            {/* Apply Button */}
            <Button
              onClick={() => {
                applyFilter();
                handleClose();
              }}
              style={{
                width: "100%",
                height: "44px",
                borderRadius: "10px",
                background:
                  isdark === "light"
                    ? iscolour?.Colour5
                    : iscolourDark?.Colour10,
                color:
                  isdark === "light"
                    ? iscolour?.Colour1
                    : iscolourDark?.Colour3,
                border: "none",
                fontWeight: "600",
              }}
              className="common-hover-btn"
            >
              Apply Filters
            </Button>
          </div>
        </Offcanvas.Body>
      </Offcanvas>

      <Row className="g-4 align-items-start">
        {/* ✅ RIGHT SIDE */}
        <Col xl={12} lg={12} md={12}>
          {/* SUMMARY */}
          <Row className="g-3">
            <Col xl={4} lg={12} md={12} sm={12}>
              <div style={cardStyle}>
                <h4 style={subtitleStyle}>{summaryData.totalSaleAmount}</h4>
                <h6 style={titleStyle}>Total Sale Amount</h6>
              </div>
            </Col>

            <Col xl={4} lg={12} md={12} sm={12}>
              <div style={cardStyle}>
                <h4 style={subtitleStyle}>{summaryData.totalQuantitySold}</h4>
                <h6 style={titleStyle}>Total Quantity Sold</h6>
              </div>
            </Col>

            <Col xl={4} lg={12} md={12} sm={12}>
              <div style={cardStyle}>
                <h4 style={subtitleStyle}>{summaryData.averageSaleAmount}</h4>
                <h6 style={titleStyle}>Average Sale Amount</h6>
              </div>
            </Col>
          </Row>
          {/* ✅ DESKTOP FILTER */}
          <div
            className="d-none d-lg-block"
            style={{
              marginTop: "20px",
              marginBottom: "10px",
              padding: "12px",
              borderRadius: "12px",
              background:
                isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour2,
              border: `1px solid ${
                isdark === "light" ? iscolour?.Colour3 : iscolourDark?.Colour10
              }`,
              boxShadow: "0 4px 10px rgba(0,0,0,0.15)",
            }}
          >
            <Row className="g-3 align-items-end">
              {/* Month */}
              <Col xl={6} lg={6} md={6} sm={12}>
                <FASDroupdownFilterBox
                  label="Month"
                  placeholder="Select Month Name"
                  data={monthList}
                  selectedValue={selectedMonth}
                  setSelectedValue={setSelectedMonth}
                  selectedId={selectedMonthId}
                  setSelectedId={setSelectedMonthId}
                  isdark={isdark}
                  iscolour={iscolour}
                  iscolourDark={iscolourDark}
                  isMulti={false}
                />
              </Col>

              {/* Sale Book */}
              <Col xl={6} lg={6} md={6} sm={12}>
                <FASDroupdownFilterBox
                  label="Sale Books"
                  placeholder="Select Sale Books"
                  data={saleBookList}
                  selectedValue={selectedSaleBook}
                  setSelectedValue={setSelectedSaleBook}
                  selectedId={selectedSaleBookId}
                  setSelectedId={setSelectedSaleBookId}
                  isdark={isdark}
                  iscolour={iscolour}
                  iscolourDark={iscolourDark}
                  isMulti={false}
                />
              </Col>

              {/* Production */}
              <Col xl={6} lg={6} md={6} sm={12}>
                <FASDroupdownFilterBox
                  label="Production Groups"
                  placeholder="Select Production Groups"
                  data={productionList}
                  selectedValue={selectedProductionGroup}
                  setSelectedValue={setSelectedProductionGroup}
                  selectedId={selectedProductionGroupId}
                  setSelectedId={setSelectedProductionGroupId}
                  isdark={isdark}
                  iscolour={iscolour}
                  iscolourDark={iscolourDark}
                  isMulti={false}
                />
              </Col>

              {/* Sale Party */}
              <Col xl={6} lg={6} md={6} sm={12}>
                <FASDroupdownFilterBox
                  label="Sale Party"
                  placeholder="Select Sale Party"
                  data={salePartyList}
                  selectedValue={selectedSaleParty}
                  setSelectedValue={setSelectedSaleParty}
                  selectedId={selectedSalePartyId}
                  setSelectedId={setSelectedSalePartyId}
                  isdark={isdark}
                  iscolour={iscolour}
                  iscolourDark={iscolourDark}
                  isMulti={false}
                />
              </Col>

              {/* Apply Button */}
              <Col xl={12} lg={12} md={12} sm={12}>
                <Button
                  onClick={applyFilter1}
                  style={{
                    width: "100%",
                    height: "44px",
                    borderRadius: "12px",
                    background:
                      isdark === "light"
                        ? iscolour?.Colour5
                        : iscolourDark?.Colour10,
                    color:
                      isdark === "light"
                        ? iscolour?.Colour1
                        : iscolourDark?.Colour3,
                    border: "none",
                    fontWeight: "600",
                  }}
                  className="common-hover-btn"
                >
                  Apply Filters
                </Button>
              </Col>
            </Row>
          </div>
          <div style={{ marginTop: "20px" }}>
            <div
              style={{
                borderRadius: "12px",
                overflow: "hidden",
                boxShadow: "0 4px 10px rgba(0,0,0,0.27)",
              }}
            >
              <div
                style={{
                  backgroundColor:
                    isdark === "light"
                      ? iscolour?.Colour5
                      : iscolourDark?.Colour4,
                  color:
                    isdark === "light"
                      ? iscolour?.Colour1
                      : iscolourDark?.Colour11,
                  padding: "14px",
                }}
              >
                <h5
                  style={{
                    fontSize: "18px",
                    margin: 0,
                    letterSpacing: "1px",
                    fontWeight: "600",
                  }}
                >
                  ITEMWISE MONTLY SALE AMOUNT
                </h5>
              </div>

              <FASTable data={getRowsdata()} columns={getColumns} />
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
};
